import type { Line } from './Line';
import type { Multi, MultiDependencies } from './Multi';
import { buildText } from './Text';

type MultiConstructor = new (problemJS: MultiDependencies, line: Line) => Multi;

export function buildDefaultMulti(
  problemJS: MultiDependencies,
  line: Line
): Multi {
  const BuildableMulti = line.multi.constructor as MultiConstructor;
  const ret = new BuildableMulti(problemJS, line);
  const text = buildText(problemJS);

  text.e = true;
  ret.add(text);

  return ret;
}
